const state = {
  listKeapCustomFields: null,
  listKeapRelationship: null
};

const mutations = {
  setListKeapCustomFields(state, payload) {
    state.listKeapCustomFields = payload;
  },
  setListKeapRelationship(state, payload) {
    state.listKeapRelationship = payload;
  },
};

const actions = {
  setListKeapCustomFields({ commit }, payload) {
    commit("setListKeapCustomFields", payload);
  },
  setListKeapRelationship({ commit }, payload) {
    commit("setListKeapRelationship", payload);
  },
};

const getters = {
  listKeapCustomFields(state) {
    return state.listKeapCustomFields;
  },
  listKeapRelationship(state) {
    return state.listKeapRelationship;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/keap.js